import { useState } from 'react';
import { useElementClick } from '../../../../hooks/element-click.hook';
import {
  CheckedChipIcon, ChipContainer, ChipTitle, CloseChipIcon, RequiredChipIcon,
} from './create-position-requirement-chip.styled';

const RequirementChip = ({
  onClick,
  onDoubleClick,
  title,
  selected,
  required,
  isSingleSelection,
}:ChipProps): JSX.Element => {
  const [isHover, setIsHover] = useState(false);

  const handleClick = useElementClick(onClick, onDoubleClick);

  const renderIcons = () => {
    if (!isSingleSelection && selected && isHover) {
      return <CloseChipIcon />;
    }

    if (required && (!isHover || isSingleSelection)) {
      return <RequiredChipIcon />;
    }

    if (selected && (!isHover || isSingleSelection)) {
      return <CheckedChipIcon />;
    }

    return null;
  };

  return (
    <ChipContainer
      title={ title }
      onClick={ handleClick }
      selected={ !!selected  }
      required={ !!required }
      onMouseEnter={ () => {
        setIsHover(true);
      } }
      onMouseLeave={ () => {
        setIsHover(false);
      } }
    >
      { renderIcons() }
      <ChipTitle> { title } </ChipTitle>
    </ChipContainer>
  );
};

export default RequirementChip;
